var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 792,
    height: 792,
    viewBox: "0 0 792 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 792,
    height: 792,
    fill: "#ffffff",
    fillOpacity: 0.8,
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#311439"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,648) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,672) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(648,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(696,696) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,720) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,576)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v14h14V0H0z M12,12H2V2h10V12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,624)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrEng);
export default __webpack_public_path__ + "static/media/QR_eng.c911c33330352c0e1fd95ad3bdb92c63.svg";
export { ForwardRef as ReactComponent };